<template>
  <div :class="$store.getters.platform === 'browser' ? 'page-bg-browser' : 'page-bg'">
    <app-loader v-if="loading"></app-loader>
    <div v-else>
      <div :id="'cat-' + category.id" class="wrapper-data page-bg-browser" v-bg="{image: category.background, alternative: true}">
        <video-bg v-if="category.trailer" ref="videoBG" :src="category.trailer" :bg="category.background"></video-bg>
        <div class="logo">
          <img :src="$store.getters.getData.logo_mono">
        </div>
        <div class="category-blur"></div>
        <div class="info-container">
          <div class="category-title">
            <img v-if="category.title_image" :src="category.title_image"/>
            <img v-else-if="category.title_image_url" :src="category.title_image_url"/>
            <h2 v-else class="title">{{category.name}}</h2>
          </div>
          <p v-if="lockedAdmin" class="text-black-shadow" style="margin-bottom: .5rem; text-align:center">{{ $t("CONTENT-DETAIL.MSG-ADMIN") }}</p>

          <div class="category-details">
            <div class="category-details-sypnosis">
              <p v-if="category.description"><span>{{category.description | truncateText(500) }}</span></p>
              <p v-else><span>{{ $t("CONTENT-DETAIL.NO-DESC") }}</span></p>
            </div>
            <div class="category-details-metadata">
              <!--<p v-if="content.duration" style="font-size: 1rem;">Duración: {{content.duration }} min</p>-->
            </div>
          </div>

          <div class="category-buttons">
            <button v-if="!locked"  v-on:click="play" v-on:keyup.enter="play" class="waves-effect waves-light btn-large btn-play focusable" tabindex="-1" v-on:keyup.down="down" :style="{ color: '#009539' }">
              <icon name="play"></icon>  Ver último programa </button>
            <button v-else-if="!lockedAdmin"  v-on:click="checkPurchase" v-on:keyup.enter="checkPurchase" class="waves-effect waves-light btn-large focusable" tabindex="-1" v-on:keyup.down="down">{{category.inapppurchase.price | currency}}</button>

            <!--<button v-if="content.trailer" v-on:click="trailer" v-on:keyup.enter="trailer" class="waves-effect waves-light btn-large focusable" tabindex="-1" v-on:keyup.down="down">
              <icon name="play"></icon>  Ver tráiler</button>-->

            <!--<button v-if="$store.getters.getData.is_favorite && $store.getters.user"  v-on:click="toFavorites" v-on:keyup.enter="toFavorites" class="waves-effect waves-light btn-large focusable" tabindex="-1" v-on:keyup.down="down">
                <icon v-if="waiting" name="spinner" spin class="center-icon"></icon>
                <icon v-if="!waiting && !content.is_favorite" name="regular/heart" class="center-icon"></icon>
                <icon v-if="!waiting && content.is_favorite" name="heart" class="center-icon"></icon>
                Añadir a favoritos
            </button>-->
          </div>
        </div>

      </div>

      <!--<hr>-->

      <!-- Temporadas -->
      <div v-if="!locked && category.child_categories && category.child_categories.length" v-for="season in seasons" v-bind:key="season.id">
        <div class="valign-wrapper wrapper-list season">
          <app-list
            :options="{
              id: 'cat-' + season.id,
              type: routeList,
              title: season.name,
              items: season.category_content,
              route: routeList,
              autoFocus: 'false',
              restrict: 'self-only',
              style: 'padding-top: 2rem !important;',
              wrapper: $el
              }"
          />
        </div>
      </div>

      <div v-if="!locked && category.is_final">
        <div class="valign-wrapper wrapper-list contents">
          <app-list
            :options="{
              id: category.id,
              type: 'card-contents',
              title: $i18n.t('CATEGORY-DETAIL.CONTENTS'),
              items: category.category_content,
              route: routeList,
              card: category.card,
              typeCat: category.type,
              style: 'padding-top: 2rem !important;',
              wrapper: $el
              }"
          />
        </div>
      </div>

      <!--<app-list v-if="category.child_categories && category.child_categories.length"
          :id="'related-contents-' + content.id"
          :type="routeList"
          :title="$i18n.t('CONTENT-DETAIL.CONTENTS')"
          :items="content.related_contents"
          :route="routeList"
          :autoFocus="false"
          :up="upList"
          :restrict="'self-only'"
          style="padding-top: 2rem;"
          @trailerPlay="pauseTrailer"
          @trailerStop="playTrailer"
          :wrapper = "$el"
          :backReplace = "true"
          ></app-list>-->

      <!-- productos relacionados -->

        <!-- contenidos relacionados -->
        <!--<app-list v-if="content.related_contents && content.related_contents.length"
          :id="'related-contents-' + content.id"
          :type="routeList"
          :title="$i18n.t('CONTENT-DETAIL.CONTENTS')"
          :items="content.related_contents"
          :route="routeList"
          :autoFocus="false"
          :up="upList"
          :restrict="'self-only'"
          style="padding-top: 2rem;"
          @trailerPlay="pauseTrailer"
          @trailerStop="playTrailer"
          :wrapper = "$el"
          :backReplace = "true"
          ></app-list>-->

        <Modal v-if="showModal" @close="closeModal">

          <!-- modal dialog -->
          <p v-if="showModal === 'dialog'" slot="body">{{ textDialog }}</p>

          <!-- modal no user -->
          <Login v-if="showModal === 'no-user'"
            slot="body"
            :title="''"
            :redirect="false"
            @onLogin="loggedIn"
          />
          <a v-if="showModal === 'no-user'" slot="footer" @click="closeModal" v-on:keyup.enter="closeModal" class="waves-effect waves-light btn-large modal-focusable" tabindex="-1">{{ $t("GENERAL.CANCEL") }}</a>

        </Modal>

      <!-- control bar -->
      <ControlBar v-if="$store.getters.getData.control_bar && $store.getters.platform !== 'browser'" :keys="keys" />

    </div>
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import SpatialNavigation from 'js-spatial-navigation'
import List from '@/components/List'
import {StatsCategoryDetail} from '@/utils/constants'
import VideoBg from '@/components/video-bg'
import Modal from '@/components/Modal'
import ControlBar from '@/components/ControlBar'
import Login from '@/components/Login'
import { setLocation, getLocation } from '@/utils/helper-functions'
const contentsService = require('@/services/contents.js')

export default {
  name: 'CategoryDetail',
  components: {
    'app-loader': Loader,
    'app-list': List,
    'video-bg': VideoBg,
    ControlBar,
    Modal,
    Login
  },
  data () {
    return {
      category: {},
      seasons: [],
      items: [],
      showModal: false,
      keys: [
        {text: this.$i18n.t('KEYS.BACK'), action: this.$i18n.t('KEYS.RETURN')},
        {text: this.$i18n.t('KEYS.OK'), action: this.$i18n.t('KEYS.SELECT')},
        {color: 'yellow', action: this.$i18n.t('KEYS.HOME')}
      ],
      waiting: false
    }
  },
  created: function () {
    const fromStore = parseInt(this.$route.params.id) === this.$store.getters.contentStackTop.id
    if (fromStore) {
      // content store
      let category = this.$store.getters.categoryStackTop
      category.trailer = false
      this.category = category
      setTimeout(() => this.initControls())
      window.Countly.q.push(['track_pageview', StatsCategoryDetail + ' ' + this.category.id + ': ' + this.category.name])
    }
    // content server
    this.getGeolocation(fromStore)
  },
  mounted: function () {
    // control keys
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-yellow', this.keyYellow)
  },
  methods: {
    getGeolocation () {
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (location) {
        this.getCategory(location.lat, location.lon)
      } else {
        if (navigator.geolocation && !window.webOS) {
          // obtenemos geolocalización (LG no lo permite)
          let options = {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: Infinity
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({lat: position.coords.latitude, lon: position.coords.longitude})
              this.getCategory(position.coords.latitude, position.coords.longitude)
            },
            () => { this.getCategory(0, 0) },
            options)
        } else {
          this.getCategory(0, 0)
        }
      }
    },
    getCategory (lat, lon) {
      // CATEGORÍA
      contentsService.getCategory(this.$route.params.id, lat, lon).then(response => {
        this.category = response.data

        // metas
        // document.title = this.category.name
        // document.querySelector('meta[name="Description"]').setAttribute('category', this.category.description.slice(0, 100))

        if (!this.locked) {
          // mostramos season
          if (!this.category.is_final) {
            this.category.child_categories.forEach(season => this.getSeason(season.id, lat, lon))
          }
          // stats content category
          window.Countly.q.push(['track_pageview', StatsCategoryDetail + ' ' + this.category.id + ': ' + this.category.name])
        } else {
          // iniciamos controles
          setTimeout(() => { this.initControls() }, 0)
          // stats category detail
          window.Countly.q.push(['track_pageview', StatsCategoryDetail + ' ' + this.category.id + ': ' + this.category.name])
        }
      })
    },
    getSeason (id, lat, lon) {
      // SEASON
      contentsService.getCategory(id, lat, lon).then(response => {
        if (!this.locked) {
          // mostramos categoría
          this.seasons.push(response.data)
          this.seasons.sort((a, b) => a.id - b.id)
        }
      })
    },
    initControls () {
      this.SN = SpatialNavigation.add({selector: '#cat-' + this.category.id + ' .focusable', restrict: 'self-only'})
      SpatialNavigation.makeFocusable()

      SpatialNavigation.focus(this.SN)
      SpatialNavigation.resume()
    },
    trailer () { this.$router.push({name: 'category-trailer', params: { id: this.category.id }}) },
    play () {
      if (this.$router.currentRoute.name === 'search-category-detail') {
        // from search
        this.$router.push({name: 'search-content-view', params: { id: this.category.category_content[this.category.category_content.length - 1].id }})
      } else {
        // from contents
        this.$router.push({name: 'content-view', params: { id: this.category.category_content[this.category.category_content.length - 1].id }})
      }
    },
    playTrailer () { if (this.$refs.videoBG) this.$refs.videoBG.play() },
    pauseTrailer () { if (this.$refs.videoBG) this.$refs.videoBG.pause() },
    checkPurchase () {
      if (!this.$store.getters.user) {
        if (this.$store.getters.platform !== 'browser') {
          this.showModal = 'no-user'
        } else {
          this.textDialog = this.$i18n.t('GENERAL.REQUIERE-LINK')
          this.showModal = 'dialog'
        }
      } else {
        this.purchase()
      }
    },
    purchase () {
      if (!this.$store.getters.user) {
        if (this.$store.getters.platform !== 'browser') {
          this.showModal = 'no-user'
        } else {
          this.textDialog = this.$i18n.t('GENERAL.REQUIERE-LINK')
          this.showModal = 'dialog'
        }
      } else {
        this.$store.commit('setPurchase', {
          type: 'cat',
          id: this.category.id,
          'inna': this.category.inapppurchase.id,
          'price': this.category.inapppurchase.price
        })
        this.$router.push({name: 'purchase-summary-content'})
      }
    },
    down: function () { SpatialNavigation.focus('#list-related-contents-' + this.content.id) },
    upList: function () { this.$el.scrollTop = 0; SpatialNavigation.focus(this.SN) },
    keyBack: function () { if (!document.getElementById('app-modal')) { this.$router.go(-1) } },
    keyYellow: function () { if (this.$store.getters.getData.control_bar && this.$store.getters.platform !== 'browser') this.$router.push({name: 'content'}) },
    closeModal: function () {
      this.showModal = false
      SpatialNavigation.focus(this.SN)
      SpatialNavigation.resume()
    },
    loggedIn: function () {
      this.textDialog = this.$i18n.t('LOGIN.WELCOME')
      this.showModal = 'dialog'
    },
    toFavorites: function () {
      if (!this.waiting) {
        this.waiting = true
        if (!this.content.is_favorite) {
          contentsService.addFavorites({content: this.content.id}).then(response => {
            this.content.is_favorite = response.data.id
            this.waiting = false
            Bus.$emit('update-list', { item: this.content, action: 'add-favorite', idFav: this.content.is_favorite })
            this.$store.getters.getData.content.is_favorite = response.data.id
          }).catch(() => {
            this.waiting = false
          })
        } else {
          contentsService.deleteFavorites(this.content.is_favorite).then(response => {
            this.content.is_favorite = 0
            this.waiting = false
            Bus.$emit('update-list', { item: this.content, action: 'remove-favorite' })
            this.$store.getters.getData.content.is_favorite = 0
          }).catch(() => {
            this.waiting = false
          })
        }
      }
    }
  },
  computed: {
    loading: function () {
      return Object.keys(this.category).length === 0
    },
    locked: function () {
      return this.category.is_premium && !this.category.is_paid
    },
    lockedAdmin: function () {
      return this.category.is_premium && !this.category.is_paid && this.category.inapppurchase.is_manual
    },
    typeList: function () {
      if (this.$router.currentRoute.name === 'search-content-detail') { return 'search-card-contents' }
      return 'card-contents'
    },
    routeList: function () {
      return 'content-detail'
    }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-yellow', this.keyYellow)
    if (this.SN) SpatialNavigation.remove(this.SN)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

.logo
  position: absolute
  right: 0
  max-width: 16vw;
  max-height: inherit;
  padding-right: 2rem;
  margin-top: 1rem;
  min-width: 156px;

  img
    max-width: 100%;
    height: auto;
    max-height: inherit;
    backdrop-filter: drop-shadow(0px 0px 0px black);
    filter: drop-shadow(2px 2px 2px black);

.wrapper-data
  position: relative;
  width: 100%;
  height: 53vw
  position: relative;
  margin: auto;
  /*max-width: 1680px;*/
  overflow: hidden;
  background-color: rgb(18,18,18);

  .category-blur
    position: absolute;
    bottom: 0;
    /*backdrop-filter: blur(10px);*/
    width: 100%;
    height: 100%;
    -webkit-mask-image: linear-gradient(to bottom,transparent 50%,#000 90%);
    background: linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, 0.6) 100%, rgba(0, 0, 0, 0.6) 100%)

  .category-title
    position: relative;
    bottom: 1em;
    text-align: center

    img
      width: 100%
      height: 100%
      visibility: none

    h2
      font-size: 2.4rem;
      font-weight: 700;
      margin: 0 0 .3rem 0!important;
      word-wrap: break-word;
      text-shadow: #000000 0.05em 0.05em 0.05em;

  .info-container
    position: absolute;
    bottom: 6rem;
    left: 6rem;
    margin: 0;
    max-width: 1680px;
    width: 30%;

    .category-buttons
      position: relative;

    .category-buttons :last-of-type
      margin-bottom: 0;

    .category-details
      position: relative;
      width: 100%;

      .category-details-sypnosis
        padding: 0;
        margin-top: 30px;
        margin-bottom: 40px;
        font-weight: 500;
        line-height: 1.37;

        p
          margin: 0;
          padding: 0;
          font-size: 1.2rem;
          font-weight: 400;
          line-height: 1.27;

      .category-details-metadata p
        margin: 0;
        padding: 0;

  .btn-large
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 6px;
    border: none;
    padding: 0 16px;
    text-align: center;
    vertical-align: middle;
    height: 51px;
    margin-bottom: 12px;
    text-transform: inherit;
    font-size: 1.3rem !important;
    font-weight: 600 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.47;
    background-color: rgba(42,42,42,1.0) !important;

    svg
      display: inline-block;
      height: 12px;
      width: 12px;
      margin-right: 6px;

  .text
    max-width: 60%;
    min-height: 57vh;
    min-width: 300px;
    clear: both;
    color: white;
    padding: 1rem;
    margin-left: 2rem;

    h2
      font-size: 2.3rem;
      font-weight: 500;
      margin: 0 0 .3rem 0!important;
      word-wrap: break-word;

    p
      font-size: 1.4rem;
      line-height: 1.4;
      margin: 0 0 .3rem 0;

  .locked
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 30vh;
    text-align: center;

hr
  height: .2rem!important;
  display: block;
  padding: 0;
  margin: 0;
  height: 0;
  border: 0;
  background-color: rgba(255, 255, 255, 0.1);

.season
  //border-bottom: 0.5px solid rgba(255,255,255,.1);
  margin-top: 2rem;

.center-icon
  font-size: 3rem
  display: inline-flex;
  vertical-align: middle;

@media (max-width: 1300px)
  .wrapper-data .info-container .category-details .category-details-sypnosis p
    font-size: 1.0rem !important
    line-height: 1.27 !important
    font-weight: 500

  .category-title
    bottom: 0em !important
    img
      width: 80% !important

@media (max-width: 960px)
  .wrapper-data
    height: 90vh

    .info-container
      width: auto
      bottom: 3rem
      left: 3rem
      right: 3rem

</style>



// WEBPACK FOOTER //
// src/templates/canal-sur/contents/content-category.vue